module.exports = __webpack_public_path__ + "static/media/appstore-4e2.9c2accf9.png";